<h1 mat-dialog-title>{{data.projet.libelle}} ({{poteaux.length}} poteaux) -
  <span class="text-lime-600" *ngIf="!displayResult()">OK</span>
  <span class="text-red-500" *ngIf="displayResult()">KO</span>
</h1>
<div mat-dialog-content>
  <table>
    <tr>
      <th>Poteau</th>
      <th>Images sur le téléphone</th>
      <th>Images sur le serveur</th>
      <th>Date d'ajout du poteau</th>
    </tr>
    <tr *ngFor="let poteau of poteaux">
      <td class="text-center">
            <span *ngIf="poteau.ok" class="text-lime-600">
              {{poteau.name}}
            </span>
        <span *ngIf="!poteau.ok" class="text-red-500">
              {{poteau.name}}
            </span>
      </td>
      <td class="text-center">{{poteau.telephone}}</td>
      <td class="text-center">{{poteau.serveur}}</td>
      <td class="text-center text-[11pt]">
        <span *ngIf="poteau.dateAdded">{{poteau.dateAdded?.seconds * 1000 | date: 'dd/MM/yyyy H:mm'}}</span>
        <span *ngIf="!poteau.dateAdded">N/D</span>
      </td>
    </tr>
  </table>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="fermer()">Fermer</button>
</div>
